import { useEffect, useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "影视分类", path: "/category" },
  { label: "影视资讯", path: "/news" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setKeyword("");
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-background-50 border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-[68px] items-center gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50 text-lg font-bold">
              道
            </span>
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950 tracking-tight whitespace-nowrap">
              一本道
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-4">
            {navItems.map((item) => {
              const active = item.path === "/" ? location.pathname === "/" : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    active
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <form onSubmit={handleSearch} className="hidden md:flex flex-1 max-w-md ml-auto">
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视作品、资讯..."
                className="w-full h-10 pl-9 pr-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-300"
              />
            </div>
          </form>

          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md bg-background-100 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 animate-fade-in">
          <form onSubmit={handleSearch} className="mb-4">
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视作品、资讯..."
                className="w-full h-10 pl-9 pr-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>
          </form>
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="px-3 py-3 rounded-md text-sm font-medium text-foreground-800 hover:bg-background-100 cursor-pointer"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}